import { render } from "./SingleSelectorWithSectionalDropdown.vue?vue&type=template&id=45ed3b63&scoped=true"
import script from "./SingleSelectorWithSectionalDropdown.vue?vue&type=script&lang=js"
export * from "./SingleSelectorWithSectionalDropdown.vue?vue&type=script&lang=js"

import "./SingleSelectorWithSectionalDropdown.vue?vue&type=style&index=0&id=45ed3b63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ed3b63"]])

export default __exports__